import fp from 'lodash/fp'
import bound from 'autobind-decorator'
import { observable, action, computed, toJS } from 'mobx'
import { isValid, isInvalid, validateAll } from 'utils/validation'

const UPPER_CASE_PATTERN = /[A-Z]/g

// TODO: Revise formRef
class ValidatedFieldModel {
  @observable id = undefined

  formRef = undefined

  name = undefined

  spec = undefined

  initialValue = undefined

  @observable value = undefined

  @observable touched = false

  @observable dirty = false

  @observable readonly = false

  constructor(name, initialValue, specFn, readonly) {
    this.id = ValidatedFieldModel.toId(name)
    this.name = name
    this.readonly = readonly
    this.initialValue = initialValue
    this.value = initialValue
    this.spec = (value) =>
      specFn(value, {
        untilFail: true,
        context: { alias: name, current: this.formRef.value },
      })
  }

  static toId(value) {
    UPPER_CASE_PATTERN.lastIndex = 0
    return value.replace(
      UPPER_CASE_PATTERN,
      (symbol) => `-${symbol.toLowerCase()}`
    )
  }

  static create(name, initialValue, spec, readonly) {
    return new ValidatedFieldModel(name, initialValue, spec, readonly)
  }

  refreshInitialValue() {
    this.initialValue = this.value
  }

  setFormRef(formRef) {
    const idArray = []
    this.formRef = formRef

    if (this.formRef.id) {
      idArray.push(this.formRef.id)
    }

    idArray.push(this.id)

    this.id = idArray.join('-')
  }

  @computed
  get pureValue() {
    return toJS(this.value)
  }

  @computed
  get error() {
    return fp.first(validateAll(this.spec, this.value))
  }

  @computed
  get isPristine() {
    return this.dirty
  }

  @computed
  get showError() {
    return this.touched && Boolean(this.error)
  }

  @computed
  get isInvalid() {
    return isInvalid(this.spec, this.value)
  }

  @computed
  get isValid() {
    return isValid(this.spec, this.value)
  }

  @action.bound
  setTouched(value) {
    this.touched = Boolean(value)
  }

  @bound
  onBlur() {
    this.setTouched(true)
  }

  @bound
  onChangeAndBlur(data) {
    this.onChange(data)
    this.onBlur()
  }

  @action.bound
  onChangeText(text) {
    this.value = text
    this.dirty = true
  }

  @action.bound
  setReadonly(readonly) {
    this.readonly = readonly
  }

  @bound
  onChange(event) {
    const { value } = event.target
    this.onChangeText(value)
  }

  @action.bound
  reset() {
    this.value = this.initialValue
    this.touched = false
    this.dirty = false
  }
}

export default ValidatedFieldModel
